module.exports = __webpack_public_path__ + "img/Staff Management.0ebc3c4b.svg";